// import React from 'react';
// import "./CartPage.scss";
// import { useSelector, useDispatch } from 'react-redux';
// import { shopping_cart } from '../../utils/images';
// import { Link } from 'react-router-dom';
// import { formatPrice } from '../../utils/helpers';
// import { getAllCarts, removeFromCart, toggleCartQty, clearCart, getCartTotal } from '../../store/cartSlice';

// const CartPage = () => {
//   const dispatch = useDispatch();
//   const carts = useSelector(getAllCarts);
//   const { itemsCount, totalAmount} = useSelector((state) => state.cart);

//   if(carts.length === 0){
//     return (
//       <div className='container my-5'>
//         <div className='empty-cart flex justify-center align-center flex-column font-manrope'>
//           <img src = {shopping_cart} alt = "" />
//           <span className='fw-6 fs-15 text-gray'>Your shopping cart is empty.</span>
//           <Link to = "/" className='shopping-btn bg-orange text-white fw-5'>Go shopping Now</Link>
//         </div>
//       </div>
//     )
//   }

//   return (
//     <div className='cart bg-whitesmoke'>
//       <div className='container'>
//         <div className='cart-ctable'>
//           <div className='cart-chead bg-white'>
//             <div className='cart-ctr fw-6 font-manrope fs-15'>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>S.N.</span>
//               </div>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>Product</span>
//               </div>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>Unit Price</span>
//               </div>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>Quantity</span>
//               </div>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>Total Price</span>
//               </div>
//               <div className='cart-cth'>
//                 <span className='cart-ctxt'>Actions</span>
//               </div>
//             </div>
//           </div>

//           <div className='cart-cbody bg-white'>
//             {
//               carts.map((cart, idx) => {
//                 return (
//                   <div className='cart-ctr py-4' key = {cart?.id}>
//                     <div className='cart-ctd'>
//                       <img
//                       src={cart?.thumbnail}
//                       alt=""
//                       className="img-cover"
//                       style={{ width: "70px"}}
//                     />
//                     </div>

//                     <div className='cart-ctd'>
//                       <span className='cart-ctxt'>{cart?.title}</span>
//                     </div>
//                     <div className='cart-ctd'>
//                       <span className='cart-ctxt'>{formatPrice(cart?.discountedPrice)}</span>
//                     </div>
//                     <div className='cart-ctd'>
//                       <div className='qty-change flex align-center'>
//                         <button type = "button" className='qty-decrease flex align-center justify-center' onClick={() => dispatch(toggleCartQty({id: cart?.id, type: "DEC"}))}>
//                           <i className='fas fa-minus'></i>
//                         </button>

//                         <div className='qty-value flex align-center justify-center'>
//                           {cart?.quantity}
//                         </div>

//                         <button type = "button" className='qty-increase flex align-center justify-center' onClick={() => dispatch(toggleCartQty({id: cart?.id, type: "INC"}))}>
//                           <i className='fas fa-plus'></i>
//                         </button>
//                       </div>
//                     </div>

//                     <div className='cart-ctd'>
//                       <span className='cart-ctxt text-orange fw-5'>{formatPrice(cart?.totalPrice)}</span>
//                     </div>

//                     <div className='cart-ctd'>
//                       <button type = "button" className='delete-btn text-danger' onClick={() => dispatch(removeFromCart(cart?.id))}><i class="fa-solid fa-trash"></i></button>
//                     </div>
//                   </div>
//                 )
//               })
//             }
//           </div>

//           <div className='cart-cfoot flex align-start justify-between py-3 bg-white'>
//             <div className='cart-cfoot-l'>
//               <button type='button' className='clear-cart-btn text-danger fs-15 text-uppercase fw-4' onClick={() => dispatch(clearCart())}>
//                 <i className='fas fa-trash'></i>
//                 <span className='mx-1'>Clear Cart</span>
//               </button>
//             </div>

//             <div className='cart-cfoot-r flex flex-column justify-end'>
//               <div className='total-txt flex align-center justify-end'>
//                 <div className='font-manrope fw-5'>Total ({itemsCount}) items: </div>
//                 <span className='text-orange fs-22 mx-2 fw-6'>{formatPrice(totalAmount)}</span>
//               </div>

//               <button type = "button" className='checkout-btn text-white bg-orange fs-16'>Check Out</button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CartPage

import React, { useEffect, useState } from "react";
import "./CartPage.scss";
import { useSelector, useDispatch } from "react-redux";
import { shopping_cart } from "../../utils/images";
import { Link } from "react-router-dom";
import { formatPrice } from "../../utils/helpers";
import {
  getAllCarts,
  removeFromCartAsync,
  toggleCartQty,
  clearCart,
  fetchCartProductsAsync,
} from "../../store/cartSlice";
import { placeOrderAsync } from "../../store/orderSlice";
import { selectUser } from "../../store/authSlice";
import { IMAGE_URL1 } from "../../utils/apiURL";
import { ToastContainer, toast } from "react-toastify"; // Importer le toast
import "react-toastify/dist/ReactToastify.css"; // Importer le style
import "./Progress.css";
import "./CartContainer.css";
import "./ShippingContainer.css";
import "./PaymentContainer.css";
import "./OrderSucessfull.css";
import { useHistory } from "react-router-dom"; // Pour la navigation

const CartPage = () => {
  const dispatch = useDispatch();
  const carts = useSelector(getAllCarts);
  const { itemsCount } = useSelector((state) => state.cart);
  const [months, setMonths] = useState(0); // Nombre de mois sélectionnés
  const [monthlyFields, setMonthlyFields] = useState([]); // Champs pour les mois
  const [summary, setSummary] = useState([]); // Récapitulatif
  const user = useSelector(selectUser);
  const [activeStep, setActiveStep] = useState(1); // Ajout d'un état pour l'étape active

  const totalAmount = carts.reduce((total, cart) => {
    // Vérifie si cart.product est défini
    if (!cart.product) {
      return total; // Ignore cet élément
    }

    const price = Number(cart.product.price);
    const quantity = Number(cart.quantity);

    if (isNaN(price) || isNaN(quantity)) {
      console.warn(
        "Price or quantity is undefined or not a number for cart:",
        cart
      );
      return total; // Ignore ce cart si le prix ou la quantité est invalide
    }

    return total + price * quantity; // Additionner le prix multiplié par la quantité
  }, 0);

  useEffect(() => {
    if (user) {
      const token = localStorage.getItem("token");
      dispatch(fetchCartProductsAsync(token));
    }
  }, [dispatch, user]);

  const handleMonthChange = (e) => {
    const selectedMonths = parseInt(e.target.value);
    if (selectedMonths > 0 && selectedMonths <= 6) {
      setMonths(selectedMonths);
      setMonthlyFields(Array(selectedMonths).fill("")); // Initialiser les champs
    }
  };

  const handleDefaultClick = () => {
    const defaultMonths = 6; // Nombre de mois par défaut
    setMonths(defaultMonths); // Met à jour le nombre de mois

    // Calculer le montant par mois
    const monthlyAmount = totalAmount / defaultMonths;

    // Pré-remplir les champs mensuels avec le montant calculé
    const fields = Array(defaultMonths).fill(monthlyAmount.toFixed(2));
    setMonthlyFields(fields);

    // Préparer le résumé
    const summaryData = fields.map((payment, index) => ({
      month: `Month ${index + 1}`,
      value: `$ ${payment}`,
    }));
    setSummary(summaryData);

    // toast.success("Default selected: 6 months assumed."); // Notification pour l'utilisateur
  };

  const handleAutoCalcul = () => {
    // Utiliser le nombre de mois actuel au lieu de 6 par défaut
    const defaultMonths = months; // Récupérer le nombre de mois sélectionné
    setMonths(defaultMonths); // Met à jour le nombre de mois

    // Calculer le montant par mois
    const monthlyAmount = totalAmount / defaultMonths;

    // Pré-remplir les champs mensuels avec le montant calculé
    const fields = Array(defaultMonths).fill(monthlyAmount.toFixed(2));
    setMonthlyFields(fields);

    // Préparer le résumé
    const summaryData = fields.map((payment, index) => ({
      month: `Month ${index + 1}`,
      value: `${payment} FCFA`,
    }));
    setSummary(summaryData);

    // toast.success(`Automatic calculation for ${defaultMonths} months applied.`); // Notification pour l'utilisateur
  };

  // Préparer le résumé pour la validation
  const prepareSummary = () => {
    const summaryData = monthlyFields.map((payment, index) => ({
      month: `Month ${index + 1}`,
      value: payment || "N/A", // Affiche N/A si le champ est vide
    }));
    setSummary(summaryData);
  };

  // Mise à jour du résumé à chaque changement de champs mensuels
  useEffect(() => {
    const summaryData = monthlyFields.map((payment, index) => ({
      month: `Month ${index + 1}`,
      value: payment || "N/A", // Affiche N/A si le champ est vide
    }));
    setSummary(summaryData);
  }, [monthlyFields]); // Mettre à jour le résumé dès que les champs mensuels changent

  // Mise à jour des champs mensuels
  const handleFieldChange = (index, value) => {
    const updatedFields = [...monthlyFields];
    updatedFields[index] = value;
    setMonthlyFields(updatedFields);
  };

  // const handleCheckout = () => {
  //   if (!user) {
  //     toast.error("You need to be logged in to place an order.");
  //     return;
  //   }

  //   const token = localStorage.getItem("token"); // Récupérer le token

  //   const orderData = {
  //     user_id: user.id, // Inclure l'ID de l'utilisateur
  //     items: carts.map((cart) => ({
  //       product_id: cart.product.id,
  //       quantity: cart.quantity,
  //     })),
  //     period: months, // Période sélectionnée
  //     month_1: monthlyFields[0], // Montant du premier mois
  //     month_2: monthlyFields[1], // Montant du deuxième mois
  //     month_3: monthlyFields[2], // Montant du troisième mois
  //     month_4: monthlyFields[3], // Montant du quatrième mois
  //     month_5: monthlyFields[4], // Montant du cinquième mois
  //     month_6: monthlyFields[5], // Montant du sixième mois
  //     total: totalAmount,
  //     token: token, // Inclure le token dans les données de la commande
  //   };

  //   // console.log("Order Details:", orderData);

  //   dispatch(placeOrderAsync(orderData)).then((result) => {
  //     if (result.error) {
  //       toast.error(result.error.message); // Gérer les erreurs lors de la commande
  //     } else {
  //       toast.success("Your order has been placed successfully!");
  //       // Vider le panier après un délai
  //       setTimeout(() => {
  //         dispatch(clearCart());
  //       }, 2000); // Délai de 2 secondes
  //     }
  //   });
  // };
  const handleCheckout = () => {
    if (!user) {
      toast.error("You need to be logged in to place an order.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Session expired. Please log in again.");
      return;
    }

    const orderData = {
      user_id: user.id,
      items: carts.map((cart) => {
        // Vérifier si product existe et a un id valide
        if (cart.product && cart.product.id) {
          return {
            product_id: cart.product.id,
            quantity: cart.quantity,
          };
        } else {
          // Si product est manquant ou id est invalide, ignorer l'élément ou attribuer une valeur par défaut
          console.error('Missing product or invalid id for this item', cart);
          return null; // ou une autre valeur par défaut
        }
      }).filter(item => item !== null), // Filtrer les éléments invalides
      period: months,
      month_1: monthlyFields[0],
      month_2: monthlyFields[1],
      month_3: monthlyFields[2],
      month_4: monthlyFields[3],
      month_5: monthlyFields[4],
      month_6: monthlyFields[5],
      total: totalAmount,
      token: token,
    };
    

    dispatch(placeOrderAsync(orderData))
      .unwrap()
      .then((data) => {
        toast.success("Your order has been placed successfully!");
        setTimeout(() => {
          dispatch(clearCart());
        }, 2000); // Vider le panier après un délai
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while placing your order."
        );
      });
  };

  const navigateToStep = (step) => {
    if (step === 3 && summary.length === 0) {
      toast.error("Please fill in the monthly fields correctly.");
      return;
    }
    setActiveStep(step);
  };

  const isMonthlyFieldsValid = () => {
    return monthlyFields.every((field) => field.trim() !== "");
  };

  const handleNextStep = () => {
    if (!isMonthlyFieldsValid()) {
      toast.error("All fields must be filled.");
      return;
    }
    navigateToStep(3);
  };

  const handleRemoveFromCart = (product) => {
    dispatch(
      removeFromCartAsync({
        product_id: product.id,
        token: localStorage.getItem("token"),
      })
    ).then(() => {
      // Récupérer à nouveau les produits du panier après la suppression
      const token = localStorage.getItem("token");
      dispatch(fetchCartProductsAsync(token));
      toast.success(`${product.product_name} has been removed from your cart!`);
    });
  };

  if (carts.length === 0) {
    return (
      <div className="container my-5">
        <div className="empty-cart flex justify-center align-center flex-column font-manrope">
          <img src={shopping_cart} alt="" />
          <span className="fw-6 fs-15 text-gray">
            Your shopping cart is empty.
          </span>
          <Link to="/" className="shopping-btn bg-orange text-white fw-5">
            Go shopping Now
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart bg-whitesmoke">
      <ToastContainer className="toast-container" />{" "}
      {/* Ajouter le ToastContainer ici */}
      <div className="step-navigation">
        {["My Cart", "Formula", "Order"].map((label, idx) => (
          <div
            key={idx}
            className={`step ${activeStep === idx + 1 ? "active" : ""}`}
            onClick={() => navigateToStep(idx + 1)}
          >
            {label}
          </div>
        ))}
      </div>
      <div className="container">
        {activeStep === 1 && (
          <div className="cart-ctable">
            <div className="cart-chead bg-white">
              <div className="cart-ctr fw-6 font-manrope fs-15">
                <div className="cart-cth">
                  <span className="cart-ctxt">S.N.</span>
                </div>
                <div className="cart-cth">
                  <span className="cart-ctxt">Product</span>
                </div>
                <div className="cart-cth">
                  <span className="cart-ctxt">Quantity</span>
                </div>
                <div className="cart-cth">
                  <span className="cart-ctxt">Total Price</span>
                </div>
                <div className="cart-cth">
                  <span className="cart-ctxt">Actions</span>
                </div>
              </div>
            </div>

            <div className="cart-cbody bg-white">
              {carts.map((cart, idx) => {
                const product = cart.product;

                // Vérifie si le produit existe
                if (!product) {
                  return null; // Ignore cet élément
                }

                const totalPrice =
                  parseFloat(product.price) * parseInt(cart.quantity);

                return (
                  <div className="cart-ctr py-3" key={cart.id}>
                    <div className="cart-ctd">
                      <img
                        src={`${IMAGE_URL1}${product.product_images1}`} // Utiliser la première image du produit
                        alt=""
                        className="img-cover"
                        style={{
                          width: "70px",
                          // borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div className="cart-ctd">
                      <span className="cart-ctxt">{product.product_name}</span>
                    </div>
                    <div className="cart-ctd">
                      <div className="qty-change flex align-center">
                        <button
                          type="button"
                          className="qty-decrease flex align-center justify-center"
                          onClick={() =>
                            dispatch(
                              toggleCartQty({ id: cart.id, type: "DEC" })
                            )
                          }
                        >
                          <i className="fas fa-minus"></i>
                        </button>

                        <div className="qty-value flex align-center justify-center">
                          {cart.quantity}
                        </div>

                        <button
                          type="button"
                          className="qty-increase flex align-center justify-center"
                          onClick={() =>
                            dispatch(
                              toggleCartQty({ id: cart.id, type: "INC" })
                            )
                          }
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <div className="cart-ctd">
                      <span className="cart-ctxt text-orange fw-5">
                        {formatPrice(totalPrice)}
                      </span>
                    </div>

                    <div className="cart-ctd">
                      <button
                        type="button"
                        className="delete-btn text-danger"
                        onClick={() => handleRemoveFromCart(product)} // Utiliser la nouvelle fonction
                      >
                        &nbsp; &nbsp; &nbsp;
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="cart-cfoot flex align-start justify-between py-3 bg-white">
              <div className="cart-cfoot-l">
                <div className="total-txt flex align-center justify-end">
                  <div className="font-manrope fw-5">
                    Total ({itemsCount}):{" "}
                  </div>
                  <span className="text-orange fs-22 mx-2 fw-6">
                    {formatPrice(totalAmount)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeStep === 2 && (
          <div className="formula-container bg-white py-4 px-3">
            <h3>Choose your payment period</h3>

            {/* Sélection du nombre de mois */}
            <div className="month-selector">
              <label htmlFor="months">Select Months (1 to 6): </label>
              <input
                type="number"
                id="months"
                min="1"
                max="6"
                value={months}
                onChange={handleMonthChange}
                className="month-input"
              />
              <button className="default-btn" onClick={handleAutoCalcul}>
                Automatic calculation
              </button>
              <button className="default-btn" onClick={handleDefaultClick}>
                Default (6 Months)
              </button>
            </div>

            {/* Champs dynamiques pour les mois */}
            <div className="monthly-fields">
              {monthlyFields.map((value, index) => (
                <div key={index} className="month-field">
                  <label>Month {index + 1}</label>
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => handleFieldChange(index, e.target.value)}
                    placeholder={`Amount for the month ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {activeStep === 3 && (
          // <div className="order-summary">
          //   <h3>Résumé de la commande</h3>
          //   <ul>
          //     {summary.map((item, index) => (
          //       <li key={index}>
          //         {item.month}: {item.value}
          //       </li>
          //     ))}
          //   </ul>
          //   <p>Total: {formatPrice(totalAmount)}</p>
          // </div>
          <div className="order-summary-container">
            <div className="order-summary-header">
              <h3>Order Summary</h3>
              <p className="order-summary-subtitle">
              Here is a summary of your order.
              </p>
            </div>

            <div className="order-summary-details">
              <div className="summary-table">
                <div className="summary-table-header">
                  <span>Month</span>
                  <span>Amount</span>
                </div>

                <div className="summary-table-body">
                  {summary.map((item, index) => (
                    <div className="summary-table-row" key={index}>
                      <span className="summary-month">{item.month}</span>
                      <span className="summary-value">${item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="order-summary-total">
              <div className="total-amount">
                <span>Total: </span>
                <span className="total-price">{formatPrice(totalAmount)}</span>
              </div>
            </div>
          </div>
        )}

        {activeStep === 1 && carts.length > 0 && (
          <div className="btns">
            <button
              className="nextbtn"
              onClick={() => {
                if (user) setActiveStep(2);
                else toast.error("You need to be logged in.");
              }}
            >
              Next
            </button>
          </div>
        )}

        {activeStep === 2 && (
          <div className="btns">
            <button
              className="backbtn"
              onClick={() => {
                if (user) setActiveStep(1);
              }}
            >
              Back
            </button>
            <button className="nextbtn" onClick={handleNextStep}>
              Next
            </button>
          </div>
        )}

        {activeStep === 3 && (
          <div className="btns">
            <button
              className="backbtn"
              onClick={() => {
                if (user) setActiveStep(2);
              }}
            >
              Back
            </button>
            <button
              className="nextbtn"
              onClick={() => {
                if (user) handleCheckout();
              }}
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartPage;
